var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('x-default-data-table',{attrs:{"x-options":_vm.tableOptions},scopedSlots:_vm._u([{key:"item.totalPoints",fn:function(ref){
var item = ref.item;
return [(item.totalPoints)?_c('span',[_vm._v(" "+_vm._s(_vm._f("currency")(item.totalPoints))+" VND")]):_c('span',[_vm._v("0 VND")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }